import * as React from "react";
import Api, {APIs} from "../../../Api";
import {Column, Row} from "../../digitalarz/data-grid/TypeDeclaration";
import ProjectSummaryContainer from "./ProjectsSummaryContainer";

import {dialogBoxRef} from "../../base/components/ContentRouter";
import ProjectSummaryEditor from "../components/editor/ProjectSummaryEditor";





const ProjectEditorPC = () => {
    const [rows, setRows] = React.useState<Row[]>([]);
    const [columns, setColumns] = React.useState<Column[]>([]);
    // const authorizedUser = useSelector((state: RootState) => state.auth.authorizedUser)
    const authorizedUser = true
    const qParams = ['donor', 'region', 'sro', 'sector'];
    const params: any = {};
    qParams.forEach((name) => {
        params[name] = 'all';
    });
    React.useEffect(() => {
        if (rows.length === 0 && columns.length === 0) {
            const url: string = APIs.MoPD_PROJECT_INFORMATION;
            Api.get(url, params).then((payload) => {
                if (payload) {
                    setRows(payload.rows);
                    setColumns(payload.columns);
                }
            });
        }
    }, [params, rows.length, columns.length]);

    const handleEditing = (selectedRow: any) => {
        if (selectedRow) {
            // console.log("Selected Row", selectedRow)
            dialogBoxRef?.current?.setContent(<><ProjectSummaryEditor data={selectedRow}/></>);
            dialogBoxRef?.current?.openDialog("Project Summary Editor");
        } else {
            alert("Please select a row");
        }
    }
    // const containerHeight = useSelector((state: any) => state.base.contentDivHeight -10);

    return (
        <React.Fragment>
            {authorizedUser ? <ProjectSummaryContainer data={rows} isEditingEnable={true} handleEditing={handleEditing} /> :
                <div style={{margin: '40px', padding: '20px'}}><h3>You are not authorized</h3></div>
            }
        </React.Fragment>
    )
}

export default ProjectEditorPC
